import { Box } from "@mui/material";
import type { DateTime } from "luxon";
import type { FC } from "react";
import { useIsTextEnlarged } from "@/hooks/useIsTextEnlarged";
import { NEUTRAL } from "@/theme/tokens";
import type { DayStats } from "@/utils/models";
import type { GapsDayHppd } from "../useGapsDayModel";
import { GapsDayStatCells } from "./GapsDayStatCells";

type Props = {
	dayStats: DayStats | undefined;
	dayHppd: GapsDayHppd | undefined;
	date: DateTime;
};

/**
 * The expanded drawer: the day's stats, two to a row. At Android's larger font sizes a figure fills a half-width
 * cell and squeezes its label to a letter per line, so each stat takes a full-width row instead.
 */
export const GapsMetricsDetail: FC<Props> = ({ dayStats, dayHppd, date }) => {
	const isTextEnlarged = useIsTextEnlarged();

	return (
		<Box
			data-testid="gaps-metrics-detail"
			sx={{
				display: "grid",
				gridTemplateColumns: isTextEnlarged ? "1fr" : "1fr 1fr",
				rowGap: 0.875,
				columnGap: 1.5,
				px: 1.625,
				py: 1.25,
				bgcolor: NEUTRAL[50],
				borderTop: `1px solid ${NEUTRAL[150]}`,
			}}
		>
			{dayStats && <GapsDayStatCells dayStats={dayStats} dayHppd={dayHppd} date={date} />}
		</Box>
	);
};
